// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get, HasPagingParameters } from "@insite/client-framework/Services/ApiService";
import { WarehouseCollectionModel } from "@insite/client-framework/Types/ApiModels";

const kscWarehousesUrl = "/api/ksc/warehouses";
const warehousesAlphabetUrl = "/api/v1/warehouses";

export interface GetWarehousesApiParameter extends ApiParameter, HasPagingParameters {
    search: string;
    latitude: number;
    longitude: number;
    radius?: number;
    onlyPickupWarehouses?: boolean;
    excludeCurrentPickupWarehouse?: boolean;
    currentPickupWarehouseId?: string;
    // XNG-Changes
    industry?: string;
    hasShowroom?: boolean;
}

export function getWarehouses(parameter: GetWarehousesApiParameter) {
    return get<WarehouseCollectionModel>(`${warehousesAlphabetUrl}/`, parameter);
}

// XNG-Changes
export interface WarehouseIndustriesModel {
    industries: string[];
}

// XNG-Changes
export function getWarehousesIndustries() {
    return get<WarehouseIndustriesModel>(`${kscWarehousesUrl}/industries`);
}
